import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "privacy",
    object: "privacy",
    header: [
      { text: "Título", value: "title" },
      { text: "Descripción", value: "description" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
